import React, { useState, useEffect, useMemo } from 'react';
import { Row, Button, Modal, Spinner, Col } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import { AG_GRID_LOCALE_PT_BR } from "../../shared/localeText";

import config from 'react-global-configuration';
import axios from 'axios';
import toastr from "toastr";
import { cnpjMask, cpfMask } from '../../shared/mask';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import data from '../../static/data/resultado_processos.json';
import { sassNull } from 'sass';


function ReportProcessos({ dados, reportData }) {
    const [load, setLoad] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [activeData, setActiveData] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [shownew, setShownew] = useState(false);
    const [shownoaccess, setShownoaccess] = useState(false);

    const dateFormat = (param) => param.value != '' ? new Date(param).toLocaleDateString("pt-br") + " " + new Date(param).toLocaleTimeString("pt-br") : '-';
    const currencyFormat = (param) => param.value != '' ? param.value.replace('R ', '').replace('$', '').toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : '';
    const documentFormat = (param) => param && param.length === 14 ? cnpjMask(param.toString()) : cpfMask(param.toString());

    // Configuração das colunas da grid
    const columnDefs = useMemo(() => [
        { headerName: "Número do Processo", field: "Número do Processo", flex: 1 },
        { headerName: "Tags", field: "Classes", flex: 1 },
        { headerName: "Polo Ativo", field: "Polo Ativo", flex: 1 },
        { headerName: "Polo Passivo", field: "Polo Passivo", flex: 1 },
        { headerName: "Ano Distribuição", field: "Ano Distribuição", flex: 1 },
        { headerName: "Tribunais", field: "Tribunais", flex: 1 },
        {
            headerName: "Status",
            field: "Arquivado",
            flex: 1,
            cellRenderer: params => {
                return (params.value && params.value !== '') ? <>{params.value === 'No' ? 'Não' : params.value}</> : '';
            }
        },
        {
            headerName: "Valor da Causa",
            field: "Valor da Causa",
            flex: 1,
            cellRenderer: params => {
                return (params.value && params.value !== '') ? <><span>{params.value}</span></> : '-';
            }
        },
        { headerName: "Assunto", field: "Assunto", flex: 1 }
        // { headerName: "UF", field: "UF", flex: 1 },
        // { headerName: "Última Movimentação", field: "Última Movimentação", flex: 1 },
        // { headerName: "Qtde Movimentações", field: "Qtde Movimentações", flex: 1 },
        // { headerName: "Data Última Verificação", field: "Data Última Verificação", flex: 1 },
        // { headerName: "Segredo de Justiça", field: "Segredo de Justiça", flex: 1 },
        // { headerName: "Assunto Principal Completo", field: "Assunto Principal Completo", flex: 1 },
        // { headerName: "Órgão Julgador", field: "Órgão Julgador", flex: 1 },
        // { headerName: "Juízes", field: "Juízes", flex: 1 },
        // { headerName: "Advogados", field: "Advogados", flex: 1 },
        // {
        //     headerName: "Data Início",
        //     field: "Data Início",
        //     flex: 1,
        //     cellRenderer: params => {
        //         return params.value && <><span>{dateFormat(params.value)}</span></>;
        //     }
        // },
    ], []);

    const defaultColDef = useMemo(() => ({
        flex: 1,
        minWidth: 150,
        sortable: true,
        filter: true,
        resizable: true,
    }), []);

    const gridOptions = {
        defaultColDef: defaultColDef,
        columnDefs: columnDefs,
        suppressContextMenu: true,
        suppressCellFocus: true,
        pagination: true,
        paginationAutoPageSize: true,
        paginateChildRows: true,
        rowSelection: "single",
        localeText: AG_GRID_LOCALE_PT_BR,
        enableCellTextSelection: false,
    };

    const getData = async () => {
        setLoad(true);
        try {
            // reportData[0].data_relatorio = '2025-03-17 14:51:39';
            // reportData[0].doc_number = '17170150000146';

            const url = config.get('urlbase') + '/processos?contract_id=' + JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&data_relatorio=' + reportData[0].data_relatorio + '&documento=' + reportData[0].doc_number;
            const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token };
            const data = (await axios.get(url, { headers })).data;
            if (data && data.Item && data.Item.processos) {
                if (data.Item.processos.length > 0) {
                    setRowData(data.Item.processos);
                } else {
                    setRowData([]);
                }
            } else {
                setShownoaccess(true);
            }
            setLoad(false);
        } catch (error) {
            setLoad(false);
            console.log(error);
            if (error.response.status === 404) {
                //setRowData([]);
                setShownoaccess(true);
            } else {
                if (error.response.status === 403) {
                    setShownoaccess(true);
                } else {
                    toastr.error('Erro ao listar processos');
                }
            }
        }
    }

    const getNewProcessData = async () => {
        try {
            const url = config.get('urlbase') + '/processos/new';
            const userInfos = JSON.parse(localStorage.getItem('userInfos'));
            const headers = { 'x-api-key': userInfos.data.Token, 'Content-Type': 'application/json' };
            
            const newProcessparams = {
                customercnpj: userInfos.data.customercnpj,
                documento: reportData[0].doc_number,
                data_relatorio: reportData[0].data_relatorio
            };

            const response = (await axios.post(url, JSON.stringify(newProcessparams), { headers: headers })).data;
            console.log(response);
        } catch (error) {
            console.log(error);
            toastr.error('Erro ao fazer uma nova busca de processos');
        }
    }

    // Carregar os dados do JSON
    useEffect(() => {
        getData(data);
    }, []);

    // Ação ao clicar em uma linha
    const onRowClicked = (event) => {
        setActiveData(event.data);
        setShowModal(true);
    };

    return (
        <>
            {shownew &&
                <Col md={4} style={{ margin: "50px auto 0 auto" }}>
                    <div class="rect-content-risks">
                        <p>Clique em "Gerar Relatório" para ver a lista de processos judiciais para esse documento</p>
                        <center>
                            <Button className='small' variant="primary" onClick={getNewProcessData}>
                                Gerar Relatório
                            </Button>
                        </center>
                    </div>
                </Col>
            }
            {shownoaccess &&
                <Col md={4} style={{ margin: "50px auto 0 auto" }}>
                    <div class="rect-content-risks">
                        <p class="rect-tx-1"><i class="bi bi-exclamation-triangle"></i> Este conteúdo exibe processos judiciais vinculados ao documento consultado.</p>
                        <p>Para acessá-lo, entre em contato com nossa equipe comercial e saiba como ativar essa funcionalidade.</p>
                    </div>  
                </Col>
            }
            {load ?
                <Row className='d-flex justify-content-center mt-3'>
                    <Spinner animation="border" variant="success" />
                </Row>
                :
                !shownoaccess && !shownew && 
                <Row style={{ height: 'calc(100vh - 480px)' }}>
                    <div className="ag-theme-quartz reportProcess" style={{ width: '100%', height: '100%' }}>
                        <AgGridReact
                            {...gridOptions}
                            rowData={rowData}
                            onRowClicked={onRowClicked}
                        />
                    </div>
                </Row>
            }
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes do Processo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData ? (
                        <>
                            <div className="d-flex justify-content-between mb-3"><div className="rect-tag small inmodal social">Social</div><div className="rect-tx-value fs-5">Peso: 3.0</div></div>

                            <p className='fs-5'><b>{activeData["Tribunais"]}</b> <span className='fs-6'>{activeData["Ano Distribuição"]}</span></p>
                            <p className='rect-tx-1 fs-6' style={{ lineHeight: "22px" }}>
                                {activeData["Número do Processo"]} <br />
                                <span className='rect-tx-value fs-6' style={{ lineHeight: "22px" }}>{activeData["Assunto"]}</span>
                            </p>

                            <Row className='scrollbar d-flex mb-5' style={{ height: 'calc(100vh - 480px)' }}>

                                {Object.keys(activeData)?.length > 0 ? Object.keys(activeData).map((key, index) => (
                                    <>
                                        {key !== 'Número do Processo' && key !== 'Tribunais' && key !== 'Ano Distribuição' && key !== 'Número do Processo' && key !== 'Assunto' ? (
                                            
                                                    key === 'Data Início' || key === 'Última Movimentação' ?
                                                        (<p className='mb-1'><b>{key}:</b> {activeData[key] !== '' ? dateFormat(`${activeData[key].split('-')[2]}-${activeData[key].split('-')[1]}-${activeData[key].split('-')[0]}`) : '-'}</p>) :
                                                    key === 'Data Última Verificação' ?
                                                        (<p className='mb-1'><b>{key}:</b> {activeData[key] !== '' ? dateFormat(activeData[key]) : '-'}</p>) :
                                                                (<p className='mb-1'><b>{key}:</b> {activeData[key] !== '' ? activeData[key] : '-'}</p>)
                                        ) : ''}

                                    </>
                                )) : ''}

                            </Row>

                        </>

                    ) : (
                        <p>Carregando...</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={() => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ReportProcessos;